import type { FaireProductEntity } from "../../entity_types/product";

export const p_rvaw475a7m: FaireProductEntity = {
  token: "p_rvaw475a7m",
  type: "product",
  name: "Faire Mystery Sock",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/b51dd2129cf0e272defbf70a8461b739f2e2bd2318b5471b90f4842186959a05.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f96010453bcbb6a942cd11dbbbc06e9f1810ab2ece6de1bc982129efe94547c2.png",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg"
  ],
  priceDollars: 3,
  description: "Throw this Mystery Pack in your cart and get a 6-pack of socks for more than half off! Popular styles only.\n\nGet these babies to gift your staff, your customers, or give a nice 'lil boost to that sweet bottom line of yours 🤑.\n\nMystery loves company! You’re welcome to order as many mystery packs as you like, but please be aware that the variety of unique styles is limited to two. If your order exceeds two, you could say... mystery repeats itself. 😆",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:17.580Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
